import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "current",
	height: "current",
	viewBox: "0 0 10 10",
	fill: "current",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.20047 0.807136C8.94047 0.547136 8.52047 0.547136 8.26047 0.807136L5.00047 4.06047L1.74047 0.800469C1.48047 0.540469 1.06047 0.540469 0.800469 0.800469C0.540469 1.06047 0.540469 1.48047 0.800469 1.74047L4.06047 5.00047L0.800469 8.26047C0.540469 8.52047 0.540469 8.94047 0.800469 9.20047C1.06047 9.46047 1.48047 9.46047 1.74047 9.20047L5.00047 5.94047L8.26047 9.20047C8.52047 9.46047 8.94047 9.46047 9.20047 9.20047C9.46047 8.94047 9.46047 8.52047 9.20047 8.26047L5.94047 5.00047L9.20047 1.74047C9.4538 1.48714 9.4538 1.06047 9.20047 0.807136Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgCloseX);
export { ForwardRef as ReactComponent };
